module.exports = flatpickr;


//////////////////
// WEBPACK FOOTER
// external "flatpickr"
// module id = lC8q
// module chunks = 44